import { API_Data_Get_Game_Response } from "@/interfaces/api/games/api_request_types"
import { API_Error, API_Response } from "@/interfaces/api/response/api_response_types"
import { API_Data_Get_Row_Response, API_Data_Get_Rows_Response } from "@/interfaces/api/rows/api_response_types"
import { fetcher } from "@/utils/helpers"

export async function getGame(id: string, locale: string, profileId?: string | null, headers?: HeadersInit ): Promise<API_Data_Get_Game_Response> {
  // console.time('GET_GAME')
  const url = `/api/games/${id}?lang=${locale}${profileId ? `&profile_id=${profileId}` : ''}`
  const res = await fetcher(url , {
    method: 'GET',
    cache: "no-store",
    credentials: 'include',
    headers
  })
  
  // console.log(res)
  const response = await res.json() as API_Response<API_Data_Get_Game_Response>
  
  if (!res.ok) throw { code: res.status, description: 'Unknow game error' } as API_Error
  if (response.status === 'error') throw response.error
  if (!response.data) throw { code: 500, description: 'Game data missing in response' } as API_Error
  // console.timeEnd('GET_GAME')

  return response.data
}

export async function getRows(locale: string, profileId?: string | null, headers?: HeadersInit): Promise<API_Data_Get_Rows_Response> {
  const url = `/api/rows?lang=${locale}${profileId ? `&profile_id=${profileId}` : ''}`
  const res = await fetcher(url, {
    method: 'GET',
    cache: "no-store",
    credentials: 'include',
    headers
  })

  const response = await res.json() as API_Response<API_Data_Get_Rows_Response>
  
  if (!res.ok) throw { code: res.status, description: 'Unknow rows error' } as API_Error
  if (response.status === 'error') throw response.error
  if (!response.data) throw { code: 500, description: 'Rows data missing in response' } as API_Error

  return response.data
}

export async function getRow(id: string, locale: string, profileId?: string | null): Promise<API_Data_Get_Row_Response> {
  const url = `/api/rows/${id}?lang=${locale}${profileId ? `&profile_id=${profileId}` : ''}`
  const res = await fetcher(url, {
    method: 'GET',
    cache: "no-store",
    credentials: 'include'
  })

  const response = await res.json() as API_Response<API_Data_Get_Row_Response>
  
  if (!res.ok) throw { code: res.status, description: 'Unknow rows error' } as API_Error
  if (response.status === 'error') throw response.error
  if (!response.data) throw { code: 500, description: 'Row data missing in response' } as API_Error

  return response.data
}

export async function getCatalogue(queryString: string) {
  const res = await fetcher('/api/games?' + queryString, {
    method: 'GET',
    cache: "no-store",
    credentials: 'include'
  })
  
  const response = await res.json() as API_Response<any>
  
  if (!res.ok) throw { code: res.status, description: 'Unknow game list error' } as API_Error
  if (response.status === 'error') throw response.error
  if (!response.data) throw { code: 500, description: 'Game list data missing in response' } as API_Error

  return response.data
}